export const changePrioritySynchronously = (children, orderedChildren) => {

    const orderedChildrenMap = new Map();

    let priority = 1;
    for (const p of orderedChildren) {
        orderedChildrenMap.set(p.id, priority++);
    }

    for (let o = 0; o < children.length; o++) {
        const id = children[o].id;
        if (orderedChildrenMap.has(id)) {
            children[o].globalPriority = orderedChildrenMap.get(id);
        } else {
            children[o].globalPriority = 0;
        }
    }

    return children;
}
